module.exports = "/_next/static/images/sa2-line-955bf251ca4496e4d51e239fa52fb3af.svg";